<template>
  <div id="modalEditarSettings">
    <q-dialog v-model="OpenDialogEditarSettings" persistent>
      <q-card style="width:600px">
        <q-card-section class="row items-center no-wrap">
          <div class="text-h6">Editar Configurações</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup @click="closeModal()" />
        </q-card-section>
        <q-separator />
        <q-card-section>
          <div class="q-pa-md">
            <div class="q-col-gutter-md row">
              <div class="col-12 q-mb-sm">
                <q-select
                  map-options
                  emit-value
                  v-model="config.whatsapps_tipo"
                  :options="tiposExibidos"
                  label="Parceiro de Integração"
                >
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-grey">Sem Resultados</q-item-section>
                    </q-item>
                  </template>
                </q-select>
              </div>
              <div class="col-12 col-md-6">
                <q-input
                  v-model="config.whatsapps_inicio"
                  label="Limitar o envio nesse período do dia"
                  mask="time"
                  :rules="['time']"
                >
                  <template v-slot:append>
                    <q-icon name="access_time" class="cursor-pointer">
                      <q-popup-proxy
                        ref="whatsappInicioRef"
                        transition-show="scale"
                        transition-hide="scale"
                      >
                        <q-time v-model="config.whatsapps_inicio" @update:model-value="closeTimeDialog" />
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </div>
              <div class="col-12 col-md-6">
                <q-input v-model="config.whatsapps_termina"
                  mask="time"
                  :rules="['time']">
                  <template v-slot:append>
                    <q-icon name="access_time" class="cursor-pointer">
                      <q-popup-proxy
                        ref="whatsappTerminaRef"
                        transition-show="scale"
                        transition-hide="scale"
                      >
                        <q-time v-model="config.whatsapps_termina" @update:model-value="closeTimeDialog" />
                      </q-popup-proxy>
                    </q-icon>
                  </template>
                </q-input>
              </div>
              <div class="col-12" v-if="tiposComUrl.includes(config.whatsapps_tipo)" >
                <q-input
                  v-model="config.whatsapps_url"
                  label="URL"
                >
                </q-input>
              </div>
              <div class="col-12 q-mt-none" v-if="tiposComCamposLegados.includes(config.whatsapps_tipo)" >
                <q-input
                  v-model="config.whatsapps_token"
                  label="Token"
                >
                </q-input>
              </div>
              <div class="col-12" v-if="config.whatsapps_tipo == 'digisac'">
                <q-input
                  v-model="config.whatsapps_time"
                  label="Tempo para fechamento da chamada"
                  hint="minutos"
                >
                </q-input>
              </div>
              <div class="col-12" v-if="config.whatsapps_tipo == 'digisac'">
                <q-input
                  v-model="config.whatsapps_topicId"
                  label="ID do Assunto do Chamado"
                >
                </q-input>
              </div>
              <div class="col-12" v-if="tiposComCamposLegados.includes(config.whatsapps_tipo)" >
                <q-input
                  v-model="config.whatsapps_departmentId"
                  label="ID do departamento"
                >
                </q-input>
              </div>
              <div class="col-12" v-if="config.whatsapps_tipo == 'digisac'">
                <q-input
                  v-model="config.whatsapps_serviceId"
                  label="ID do serviço"
                >
                </q-input>
              </div>
              <div class="col-12" v-if="tiposComCamposLegados.includes(config.whatsapps_tipo)" >
                <q-input
                  v-model="config.whatsapps_userId"
                  label="ID do usuário"
                >
                </q-input>
              </div>
              <div class="col-12" v-if="config.whatsapps_tipo == 'twilio'">
                <q-input
                  v-model="config.whatsapps_from_number"
                  label="Número de telefone de envio"
                >
                </q-input>
              </div>
              <div class="col-12" v-if="config.whatsapps_tipo === 'dourasoft'">
                <q-input
                  v-model="config.whatsapps_from_number"
                  label="Identificação do número de telefone"
                >
                </q-input>
              </div>
              <div class="col-12" v-if="config.whatsapps_tipo === 'dourasoft'">
                <q-input
                  v-model="config.whatsapps_oficial_token"
                  label="Token de acesso da Meta"
                  :type="mostrarTokenMeta ? 'text' : 'password'"
                  :hint="dicaTokenMeta"
                >
                  <template v-slot:append>
                    <q-icon
                      :name="mostrarTokenMeta ? 'visibility_off' : 'visibility'"
                      class="cursor-pointer"
                      @click="mostrarTokenMeta = !mostrarTokenMeta"
                    />
                  </template>
                </q-input>
              </div>
              <div class="col-12" v-if="config.whatsapps_tipo === 'uazapi' && config.whatsapps_uazapi_instance">
                <q-banner class="bg-grey-3 q-mt-sm" rounded>
                  <div class="text-subtitle2">Instância: {{ config.whatsapps_uazapi_instance }}</div>
                  <div class="text-subtitle2">Token: {{ config.whatsapps_uazapi_token ? 'Configurado ✓' : 'Não configurado' }}</div>
                  <template v-slot:action>
                    <q-btn
                      flat
                      dense
                      label="Recriar Instância"
                      color="negative"
                      @click="recriarInstanciaUazapi"
                    />
                  </template>
                </q-banner>
              </div>
              <div class="col-12" v-if="config.whatsapps_tipo === 'uazapi'">
                <q-input
                  v-model="config.whatsapps_uazapi_intervalo"
                  label="Intervalo entre msgs (seg)"
                  type="number"
                >
                </q-input>
              </div>
              <div class="col-12" v-if="config.whatsapps_tipo === 'dourasat'">
                <q-input
                  v-model="config.whatsapps_dourasat_api_key"
                  label="Chave da API DouraSat"
                  :type="mostrarChaveDourasat ? 'text' : 'password'"
                  hint="Gere no painel DouraSat, em Integrações → Acesso à API. A chave já salva aparece mascarada; digite uma nova para substituir."
                >
                  <template v-slot:append>
                    <q-icon
                      :name="mostrarChaveDourasat ? 'visibility_off' : 'visibility'"
                      class="cursor-pointer"
                      @click="mostrarChaveDourasat = !mostrarChaveDourasat"
                    />
                  </template>
                </q-input>
              </div>
              <div class="col-12" v-if="config.whatsapps_tipo === 'dourasat'">
                <q-btn
                  flat
                  dense
                  icon="sync"
                  label="Salvar e verificar conexão"
                  class="bg-primary text-white q-mb-sm"
                  :loading="verificandoDourasat"
                  @click="salvarEVerificarDourasat"
                />
                <q-banner
                  dense
                  v-if="statusDourasat"
                  class="q-mb-sm"
                  :class="statusDourasat.success ? 'bg-green-1 text-green-9' : 'bg-red-1 text-red-9'"
                >
                  <template v-slot:avatar>
                    <q-icon :name="statusDourasat.success ? 'check_circle' : 'error'" />
                  </template>
                  <span v-if="statusDourasat.success">
                    Integração ativa — {{ canaisDourasat.length }} canal(is) disponível(is).
                  </span>
                  <span v-else>{{ statusDourasat.message }}</span>
                </q-banner>
                <q-select
                  map-options
                  emit-value
                  v-model="config.whatsapps_dourasat_canal"
                  :options="canaisDourasat"
                  label="Canal de envio"
                  :disable="!canaisDourasat.length"
                  :hint="canaisDourasat.length
                    ? 'Só aparecem os canais conectados na sua conta DouraSat.'
                    : 'Salve a chave e clique em verificar para carregar os canais.'"
                />
              </div>
              <div class="col-12" v-if="config.whatsapps_tipo === 'dourasat'">
                <q-input
                  v-model="config.whatsapps_dourasat_intervalo"
                  label="Intervalo entre msgs (seg)"
                  type="number"
                >
                </q-input>
              </div>
            </div>
          </div>
        </q-card-section>
        <q-card-section>
          <div v-if="tiposComQrcode.includes(config.whatsapps_tipo)">
            <div v-if="carregando && !qrcode" class="row flex-center q-ma-none">
              <q-card-section class="text-center q-pa-none">
                <div class="text-subtitle1 q-mb-md">{{dourasoftServiceMsg}}</div>
                <q-spinner color="grey-10" size="5em"/>
              </q-card-section>
            </div>
            <div v-else-if="tryAgain && !qrcode" class="row flex-center q-ma-none">
              <q-card-section class="text-center q-pa-none">
                <div class="text-subtitle1 q-mb-md">{{dourasoftServiceMsg}}</div>
                <q-btn
                  flat
                  label="Tentar novamente"
                  class="bg-primary text-white"
                  @click="estabelecerConexaoWhatsapp"
                  style="margin-right: 22px; margin-bottom: 10px"
                >
                </q-btn>
              </q-card-section>
            </div>
            <div v-else-if="qrcode && conexao !== 'conectado'" class="row flex-center q-pa-none">
              <q-card-section class="text-center q-ma-none">
                <div class="text-subtitle1 q-mb-md">{{dourasoftServiceMsg}}</div>
                <div style="position: relative; display: inline-block;">
                  <img :src="qrcode"/>
                </div>
                <div class="text-caption text-grey-7 q-mt-sm">
                  Aguardando a leitura — a página atualiza sozinha.
                </div>
              </q-card-section>
            </div>
            <div v-else-if="estabelecerConexao && conexao !== 'conectado'" class="row flex-center q-pa-none">
              <q-card-section class="text-center q-pa-none">
                <div class="text-subtitle1 q-mb-md">{{dourasoftServiceMsg}}</div>
                <q-badge color="red" label="Desconectado" class="q-mb-md" />
                <div>
                  <q-btn
                    flat
                    label="Estabelecer conexão"
                    class="bg-primary text-white"
                    @click="estabelecerConexaoWhatsapp"
                    style="margin-right: 22px; margin-bottom: 10px"
                  >
                  </q-btn>
                </div>
              </q-card-section>
            </div>
            <div v-else-if="conexao === 'conectado' && tiposComQrcode.includes(tipoWhatsapp)" class="row flex-center q-pa-none">
              <q-card-section class="text-center q-ma-none q-pa-none">
                <q-badge color="green" label="Conectado" class="q-mb-md" />
                <div class="text-subtitle2">Usuário está conectado no Whatsapp!</div>
                <div class="text-subtitle2">Nome: {{ conexaoInfo.nome }}</div>
                <div class="text-subtitle2">Número: {{ conexaoInfo.numero }}</div>
                <q-avatar v-if="conexaoInfo.profilePicUrl">
                  <img :src="conexaoInfo.profilePicUrl">
                </q-avatar>
              </q-card-section>
            </div>
          </div>
        </q-card-section>
        <q-card-actions align="right" class="text-primary">
          <div v-if="tiposComQrcode.includes(tipoWhatsapp) && conexao === 'conectado'">
            <q-btn
              flat
              label="Desconectar"
              clickable
              @click="desconectarUsuario"
              class="bg-negative text-white"
              style="margin-right: 22px; margin-bottom: 10px"
            >
            </q-btn>
            <q-btn
              flat
              label="Salvar"
              clickable
              @click="saveEditedSettings"
              class="bg-positive text-white"
              style="margin-right: 22px; margin-bottom: 10px"
            >
            </q-btn>
          </div>
          <div v-else>
            <q-btn
              flat
              label="Salvar"
              clickable
              @click="saveEditedSettings"
              class="bg-positive text-white"
              style="margin-right: 22px; margin-bottom: 10px"
            >
            </q-btn>
          </div>
        </q-card-actions>
      </q-card>
    </q-dialog>


  </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "@/axios-auth";
import { Notify, Dialog } from "quasar";
export default {
  name: "modal-editar-settings",

  data() {
    return {
      recommended: false,
      config: {},
      ultimaConfig: {},
      configDefault: {},
      novoTipo: false,
      tryAgain: false,
      dourasoftServiceMsg: '',
      qrcode: null,
      qrcodeBase64: null,
      estabelecerConexao: false,
      // Providers que conectam por leitura de QR code
      tiposComQrcode: ['dourasoftService', 'uazapi'],
      // Lista de quem USA cada campo, e nao de quem nao usa: com condicao
      // negativa, todo parceiro novo herda campos que nao sao dele.
      tiposComUrl: ['digisac', 'dtnetwork', 'botconversa'],
      tiposComCamposLegados: ['digisac', 'dtnetwork', 'botconversa', 'twilio'],
      mostrarChaveDourasat: false,
      mostrarTokenMeta: false,
      // Vem do GET /whatsapp/config; sem resposta, trata como sem plano.
      planoWhatsappDourasoft: false,
      verificandoDourasat: false,
      canaisDourasat: [],
      statusDourasat: null,
      tipos: [
        {
          value: 'digisac',
          label: 'Digisac',
        },
        {
          value: 'dtnetwork',
          label: 'DT Network',
        },
        {
          value: 'botconversa',
          label: 'BotConversa',
        },
        {
          value: 'twilio',
          label: 'Twilio',
        },
        {
          value: 'dourasoft',
          label: 'DouraSoft API',
        },
        {
          value: 'uazapi',
          label: 'DouraSoft Servidor 1',
        },
        {
          value: 'dourasoftService',
          label: 'DouraSoft Servidor 2',
        },
        {
          value: 'dourasat',
          label: 'DouraSat',
        },
      ],
      conexaoInfo: {
        nome: '',
        numero: '',
        profilePicUrl: '',
      },
      pollingInterval: null,
      carregando: false,
    };
  },
  computed: {
    ...mapGetters([
      "OpenDialogEditarSettings",
      "defaultOptions",
      "conexao",
      "tipoWhatsapp",
    ]),
    tipoAtual(){
      return this.config.whatsapps_tipo;
    },
    // O mesmo provider `dourasoft`: com o plano envia pela conta da DouraSoft
    // ("DouraSoft API"); sem o plano, só com o token da empresa ("Meta API").
    tiposExibidos(){
      return this.tipos.map((tipo) => (
        tipo.value === 'dourasoft'
          ? { ...tipo, label: this.planoWhatsappDourasoft ? 'DouraSoft API' : 'Meta API' }
          : tipo
      ));
    },
    dicaTokenMeta(){
      const mascarado = 'O token já salvo aparece mascarado; digite um novo para substituir.';

      return this.planoWhatsappDourasoft
        ? `Opcional: vazio envia pelo número da DouraSoft. ${mascarado}`
        : `Obrigatório: token de usuário do sistema da sua conta na Meta, com permissão de envio. ${mascarado}`;
    },
    // O /whatsapp/status decide pelo tipo GRAVADO. Enquanto a DouraSat não
    // estiver salva, verificar mandaria o backend pelo parceiro antigo.
    dourasatSalvo(){
      return this.ultimaConfig.whatsapps_tipo === 'dourasat';
    }
  },
  methods: {
    closeTimeDialog() {
      this.$refs.whatsappInicioRef.hide();
      this.$refs.whatsappTerminaRef.hide();
    },
    closeModal() {
      this.recommended = false;
      this.estabelecerConexao = false;
      this.tryAgain = false;
      this.carregando = false;
      this.mostrarTokenMeta = false;
      this.config = Object.assign({}, this.ultimaConfig);
      this.pararPolling();
      this.limparQrcode();
      this.$store.commit("OpenDialogEditarSettings", false);
    },
    setDefaultOptions() {
      const token = this.config.whatsapps_token;

      this.config = Object.assign({}, this.configDefault);
      this.config.whatsapps_token = token;
    },
    saveEditedSettings() {
      let url = "/whatsapp/config";

      axios.post(url, this.config)
        .then(res => {
          if (!res.data.success) {
            Notify.create({
              message: res.data.message,
              color: "red",
              position: "top-right"
            });
            return;
          }

          Notify.create({
            message: res.data.message,
            color: "green",
            position: "top-right"
          });
          this.getConfig(false);
          this.closeModal();
        })
        .catch(() => {
          Notify.create({
            message: "Houve um erro ao salvar as configurações, tente novamente!",
            color: "red",
            position: "top-right"
          });
        });
    },
    decodeImage(qr){
      // O backend devolve o mesmo QR enquanto ele é válido; recriar o blob a
      // cada polling faria a imagem piscar sem necessidade.
      if (qr === this.qrcodeBase64) {
        this.dourasoftServiceMsg = 'Leia este QRcode com o seu Whatsapp:';
        return;
      }

      const base64Image = qr.split(",")[1];
      // `Buffer` only worked here because webpack 4 polyfilled Node globals into the
      // bundle; in the browser it is a ReferenceError. atob() returns the same binary
      // string for standard base64.
      const binaryString = atob(base64Image);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);

      for (let i = 0; i < len; ++i) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      const blob = new Blob([bytes], { type: "image/png" });
      this.limparQrcode();
      this.qrcodeBase64 = qr;
      this.qrcode = URL.createObjectURL(blob);
      this.dourasoftServiceMsg = 'Leia este QRcode com o seu Whatsapp:';
    },
    limparQrcode(){
      if (this.qrcode) {
        URL.revokeObjectURL(this.qrcode);
      }
      this.qrcode = null;
      this.qrcodeBase64 = null;
    },
    getConfig(carregarCanais = true) {
      return axios.get("/whatsapp/config")
        .then(res => {
          if (!res.data.success) {
            Notify.create({
              message: "Não foi possível recuperar as configurações, ou você não possui permissão!",
              color: "red",
              position: "top-right"
            });
            return;
          }
          this.$store.commit("tipoWhatsapp", res.data.atual.whatsapps_tipo);
          this.$store.commit("canalDourasat", res.data.atual.whatsapps_dourasat_canal);

          const statusObj = res.data.status && res.data.status.responseObject
            ? res.data.status.responseObject
            : null;

          if (statusObj && statusObj.connectionStatus == 'open') {
            this.$store.commit("conexao", 'conectado');
            this.conexaoInfo.nome = statusObj.profileName || '';
            this.conexaoInfo.numero = statusObj.ownerJid
              ? statusObj.ownerJid.split('@')[0]
              : '';
            this.conexaoInfo.profilePicUrl = statusObj.profilePicUrl || '';
          } else if (statusObj) {
            this.$store.commit("conexao", 'desconectado');
          }

          this.config = Object.assign({}, res.data.atual);
          this.ultimaConfig = Object.assign({}, res.data.atual);
          this.configDefault = res.data.default;
          this.planoWhatsappDourasoft = res.data.plano_whatsapp_dourasoft === true;

          if (carregarCanais && this.dourasatSalvo) {
            this.carregarCanaisDourasat();
          }
        })
        .catch(err => {
          Notify.create({
            message: "Não foi possível recuperar as configurações, ou você não possui permissão!",
            color: "red",
            position: "top-right"
          });
        });
    },
    // O /whatsapp/status decide pelo tipo GRAVADO, entao verificar sem salvar
    // mandaria o backend pelo parceiro anterior. Um botao so faz as duas coisas.
    salvarEVerificarDourasat() {
      this.verificandoDourasat = true;

      return axios.post("/whatsapp/config", this.config)
        .then(res => {
          if (!res.data.success) {
            Notify.create({
              message: res.data.message || "Não foi possível salvar a configuração.",
              color: "red",
              position: "top-right"
            });

            return null;
          }

          this.ultimaConfig = Object.assign({}, this.config);
          this.$store.commit("tipoWhatsapp", this.config.whatsapps_tipo);
          this.$store.commit("canalDourasat", this.config.whatsapps_dourasat_canal);

          return axios.get("/whatsapp/status");
        })
        .then(res => {
          if (res) {
            this.aplicarStatusDourasat(res.data);
          }
        })
        .catch(() => {
          Notify.create({
            message: "Não foi possível falar com a DouraSat, tente novamente.",
            color: "red",
            position: "top-right"
          });
        })
        .finally(() => {
          this.verificandoDourasat = false;
        });
    },
    // Leitura pura, usada ao abrir a tela com a DouraSat ja gravada.
    carregarCanaisDourasat() {
      this.verificandoDourasat = true;

      return axios.get("/whatsapp/status")
        .then(res => {
          this.aplicarStatusDourasat(res.data);
        })
        .catch(() => {
          this.statusDourasat = {
            success: false,
            message: "Não foi possível falar com a DouraSat.",
          };
        })
        .finally(() => {
          this.verificandoDourasat = false;
        });
    },
    // A lista de canais vem do /channels da propria conta: oferecer um canal
    // que nao esta conectado faz a mensagem cair no vazio sem erro visivel.
    aplicarStatusDourasat(data) {
      const disponiveis = data.canaisDisponiveis || [];

      this.canaisDourasat = disponiveis.map(canal => ({
        value: canal.id,
        label: canal.numero ? `${canal.rotulo} — ${canal.numero}` : canal.rotulo,
      }));

      this.statusDourasat = {
        success: !!data.success,
        message: data.message || "",
      };

      // Alimenta o selo da tela de WhatsApp: sem isso a DouraSat ficava sempre
      // como "Sem parceiro de integração ativo".
      this.$store.commit("conexao", data.success ? "conectado" : "desconectado");
    },
    recriarInstanciaUazapi() {
      Dialog.create({
        title: "Recriar Instância",
        message: "Isso irá criar uma nova instância. A atual será desconectada. Confirmar?",
        cancel: "Cancelar",
        persistent: true
      })
      .onOk(() => {
        this.config.whatsapps_uazapi_token = '';
        this.config.whatsapps_uazapi_instance = '';
      });
    },
    // Fluxo único de QR code: o backend normaliza a resposta de todos os
    // providers (status.responseObject.connectionStatus + qrcode.base64).
    gerarQrcode() {
      if (!this.tiposComQrcode.includes(this.config.whatsapps_tipo)) return;

      this.tryAgain = false;
      this.estabelecerConexao = false;
      this.carregando = true;
      if (!this.qrcode) {
        this.dourasoftServiceMsg = 'Gerando o QRcode para o Whatsapp, isso pode demorar um pouco...';
      }

      let url = "/whatsapp/status?get-qrcode=1";
      axios.get(url)
        .then(res => {
          // O interceptor resolve erro de HTTP como { error } — não há res.data.
          if (res.error || !res.data) {
            this.tratarFalhaQrcode(res.error && res.error.message);
            return;
          }

          let data = res.data;

          if (!data.success) {
            this.tratarFalhaQrcode(data.message);
            return;
          }

          if (data.status && data.status.responseObject && data.status.responseObject.connectionStatus) {
            const connStatus = data.status.responseObject.connectionStatus;
            if (connStatus === 'open') {
              this.$store.commit("conexao", 'conectado');
              this.$store.commit("tipoWhatsapp", this.config.whatsapps_tipo);
              this.conexaoInfo.nome = data.status.responseObject.profileName || '';
              this.conexaoInfo.numero = data.status.responseObject.ownerJid
                ? data.status.responseObject.ownerJid.split('@')[0]
                : '';
              this.conexaoInfo.profilePicUrl = data.status.responseObject.profilePicUrl || '';
              this.limparQrcode();
              this.pararPolling();
              this.carregando = false;
              return;
            } else if (connStatus === 'connecting') {
              this.$store.commit("conexao", 'conectando');
            } else {
              this.$store.commit("conexao", 'desconectado');
            }
          }

          if (data.qrcode && data.qrcode.base64) {
            this.decodeImage(data.qrcode.base64);
          }

          this.carregando = false;
        })
        .catch(err => {
          this.tratarFalhaQrcode(err && err.message);
        });
    },
    // Um QR já na tela continua válido: não apaga nem interrompe o polling por
    // causa de uma resposta ruim isolada. Com QR na tela a falha é transitória e
    // não vira notificação, senão o polling de 3s vira uma enxurrada de toasts.
    tratarFalhaQrcode(mensagem) {
      this.carregando = false;

      if (this.qrcode) {
        return;
      }

      Notify.create({
        message: mensagem || 'Erro ao gerar conexão',
        color: "red",
        position: "top-right"
      });

      this.dourasoftServiceMsg = 'Houve um erro, deseja tentar novamente?';
      this.tryAgain = true;
      this.pararPolling();
    },
    estabelecerConexaoWhatsapp() {
      this.gerarQrcode();
      this.iniciarPolling();
    },
    iniciarPolling() {
      this.pararPolling();
      this.pollingInterval = setInterval(this.gerarQrcode, 3000);
    },
    pararPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },
    desconectarUsuario() {
      this.pararPolling();

      let url = "/whatsapp/status?delete-conexao=1";
      axios.delete(url)
      .then(res =>{
        if (res.error || !res.data || res.data.success == false) {
          Notify.create({
            message: (res.data && res.data.message) || 'Erro ao desconectar',
            color: "red",
            position: "top-right"
          });
          return;
        }

        this.dourasoftServiceMsg = res.data.message;
        this.$store.commit("conexao", 'desconectado');
        this.limparQrcode();

        this.conexaoInfo = {
          nome: '',
          numero: '',
          profilePicUrl: '',
        };

        this.estabelecerConexao = this.tiposComQrcode.includes(this.config.whatsapps_tipo);

        Notify.create({
          message: res.data.message,
          color: "green",
          position: "top-right"
        });
      })
      .catch(err =>{
        Notify.create({
          message: (err && err.message) || 'Erro ao desconectar',
          color: "red",
          position: "top-right"
        });
      });
    }
  },
  mounted() {
    this.getConfig();
  },
  beforeUnmount() {
    this.pararPolling();
    this.limparQrcode();
  },
  watch: {
    recommended(val) {
      if (val) {
        this.setDefaultOptions();
      }
    },
    tipoAtual(valorNovo, valorAntigo){
      const tiposConexao = this.tiposComQrcode;
      // Trocar de provider invalida o QR e o polling do anterior.
      this.pararPolling();
      this.limparQrcode();
      if(tiposConexao.includes(valorNovo) && valorAntigo != undefined && (this.conexao !== "conectado" || this.tipoWhatsapp !== valorNovo)){
        this.estabelecerConexao = true;
        this.dourasoftServiceMsg = 'Deseja estabelecer uma conexão?';
      }
      if(!tiposConexao.includes(valorNovo) && tiposConexao.includes(valorAntigo) && this.conexao === "conectado" && this.tipoWhatsapp === valorAntigo){
        Dialog.create({
        title: "Você será desconectado do Whatsapp",
        message: "Tem certeza que deseja fazer isto?",
        cancel: "Cancelar",
        persistent: true
        })
        .onOk(() => {
          this.desconectarUsuario();
        })
        .onCancel(() => {
          this.config.whatsapps_tipo = valorAntigo;
        });
      }
    },
    OpenDialogEditarSettings(valorNovo){
      const tipo = this.tipoAtual;
      const tiposConexao = this.tiposComQrcode;

      // Modal fechado não deve continuar consultando o backend.
      if(!valorNovo){
        this.pararPolling();
        return;
      }

      if(tiposConexao.includes(tipo) && this.conexao !== "conectado"){
        this.estabelecerConexao = true;
        this.dourasoftServiceMsg = 'Deseja estabelecer uma conexão?';
      }
      if(tiposConexao.includes(tipo) && this.conexao === "conectado" && this.tipoWhatsapp === tipo){
        this.dourasoftServiceMsg = 'Usuário está conectado no Whatsapp!';
      }
    },
  }
};
</script>
